export default "__VITE_ASSET__C4XBf6hL__"